module.exports = __webpack_public_path__ + "static/img/3.c7a5159.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/zh/3.png
// module id = fGrR
// module chunks = 0